import { Form, message, Spin, Table } from "antd";
import { useEffect, useState } from "react";
import { fmtDate } from "../../extensions/utils";
import { getTableColumn } from "../../extensions/helper";
import { serverFetch } from "../../server";
import { isMobile, menuSize } from "../../extensions/design";
import ClientItemVisit from "./client-item-visit";
import { DownOutlined, RightOutlined } from "@ant-design/icons";

const ClientVisits = ({ id, exposeOnRefresh }) => {
  const [form] = Form.useForm();
  const [itmVisitsList, setItmVisitsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedVisit, setSelectedVisit] = useState([]);
  const [visitSalesMap, setVisitSalesMap] = useState({});
  const [visitSalesLoadingMap, setVisitSalesLoadingMap] = useState({});

  const getVisitsData = () => {
    setLoading(true);
    serverFetch(`visit/client/${id}`)
      .then((data) => {
        setItmVisitsList(data);
        setSelectedVisit([]);
        setVisitSalesMap({});
        setVisitSalesLoadingMap({});
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage || "Ошибка загрузки");
      });
  };

  useEffect(() => {
    getVisitsData();
  }, []);

  useEffect(() => {
    if (exposeOnRefresh) {
      exposeOnRefresh(() => getVisitsData);
    }
  }, [exposeOnRefresh]);

  const loadVisitSales = (visitId) => {
    if (visitSalesMap[visitId] || visitSalesLoadingMap[visitId]) return;
    setVisitSalesLoadingMap((prev) => ({ ...prev, [visitId]: true }));
    serverFetch(`sale/ListByVisit/${visitId}`)
      .then((data) => {
        setVisitSalesMap((prev) => ({ ...prev, [visitId]: data || [] }));
        setVisitSalesLoadingMap((prev) => ({ ...prev, [visitId]: false }));
      })
      .catch((e) => {
        setVisitSalesLoadingMap((prev) => ({ ...prev, [visitId]: false }));
        message.error(e.userMessage || "Ошибка загрузки продаж");
      });
  };

  const onVisitRowClick = (record) => {
    setSelectedVisit((prev) => {
      const expanded = prev.includes(record.id) ? [] : [record.id];
      if (expanded.length) loadVisitSales(record.id);
      return expanded;
    });
  };

  const columns = [
    getTableColumn("id", "#", { type: "number", defaultSortOrder: "descend" }, itmVisitsList),
    /* getTableColumn("vid", "Вид", { type: "number"}, itmVisitsList), */
    getTableColumn("docDate", "Дата", { type: "date",  formatFn: fmtDate }, itmVisitsList),
    /* getTableColumn("syma", "Сумма", { type: "string" }, itmVisitsList), */
    getTableColumn("saleId", "# Абонемента", { type: "number" }, itmVisitsList),
    /* getTableColumn("sellDate", "Продан", { type: "date", formatFn: fmtDate }, itmVisitsList), */
    getTableColumn("productName", "Абонемент", { type: "string" }, itmVisitsList),
  ];

  const salesColumns = [
    getTableColumn("productName", "Товар / услуга", { type: "string" }, []),
    getTableColumn("price", "Цена", { type: "number" }, []),
    getTableColumn("qty", "Кол.", { type: "number" }, []),
    getTableColumn("discountPrc", "Скидка", { type: "number" }, []),
    getTableColumn("syma", "Сумма", { type: "number" }, []),
    getTableColumn("debet", "К оплате", { type: "number" }, []),
  ];

  const renderedTable = !isMobile ? [
    <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
      <Table
        dataSource={itmVisitsList}
        loading={loading}
        columns={columns}
        size="small"
        className="table-item"
        pagination={false}
        rowKey="id"
        rowClassName={(_, index) => (index % 2 === 0 ? "row-even" : "row-odd")}
        onRow={(record) => ({ onClick: () => onVisitRowClick(record) })}
        rowSelection={{ type: "radio", selectedRowKeys: selectedVisit, renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
        expandable={{
          expandedRowKeys: selectedVisit,
          onExpand: (expanded, record) => {
            const next = expanded ? [record.id] : [];
            if (expanded) loadVisitSales(record.id);
            setSelectedVisit(next);
          },
          rowExpandable: () => true,
          expandIcon: ({ expanded, onExpand, record }) => expanded
            ? <DownOutlined onClick={(e) => { onExpand(record, e); e.stopPropagation(); }} />
            : <RightOutlined onClick={(e) => { onExpand(record, e); e.stopPropagation(); }} />,
          expandedRowRender: (record) => {
            const salesLoading = !!visitSalesLoadingMap[record.id];
            const sales = visitSalesMap[record.id] || [];
            if (salesLoading) return <Spin size="small" />;
            if (!sales.length) return <div>Нет продаж по визиту</div>;
            return (
              <Table
                dataSource={sales}
                columns={salesColumns}
                size="small"
                rowKey="id"
                pagination={false}
              />
            );
          },
          className: "cl-abons-expandable",
        }}
      />
    </Form>
  ] : [
    <Form form={form} colon={false} disabled={loading} style={{marginTop: "8px"}}>
      {(itmVisitsList.length === 0 && !loading) ?
        <div style={{ textAlign: "center", marginTop: "20px", fontSize:"14px" }}>Нет данных
        </div> : <></>}
      <div className="client-items" style={{height: window.innerHeight - menuSize, overflowY: "scroll", overflowX: "clip"}}>
        {itmVisitsList.map((item) => (
          <ClientItemVisit
            item={item}
            key={item.id}
            expanded={selectedVisit.includes(item.id)}
            sales={visitSalesMap[item.id] || []}
            loading={!!visitSalesLoadingMap[item.id]}
            onExpand={() => onVisitRowClick(item)}
          />
        ))}
      </div>
    </Form>
  ]
  return (
    <>
      {renderedTable}
    </>
  );
};

export default ClientVisits;
